require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-financial-education-calculators.json") })
        }
      }, "path---es-financial-education-calculators");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-financial-education-calculators!./.cache/json/es-financial-education-calculators.json
// module id = 2490
// module chunks = 231608221292675